import React from "react";
import type { PropsWithChildren } from "react";
import type { ContainerProps } from "@mui/material";
import { Box, Container, Paper } from "@mui/material";

type PaperLayoutProps = PropsWithChildren<{
  maxWidth?: ContainerProps["maxWidth"];
}>;

export function PaperLayout(props: PaperLayoutProps) {
  const { children, maxWidth } = props;
  return (
    <Container maxWidth={maxWidth} disableGutters={true}>
      <Paper>
        <Box
          sx={{
            padding: 2,
          }}
        >
          {children}
        </Box>
      </Paper>
    </Container>
  );
}
